import { Divider, DividerProps, makeStyles } from '@material-ui/core';
import clsx from 'clsx';

type WbSelectInlineDividerProps = DividerProps;

const useStyles = makeStyles(
  theme => ({
    root: {
      color: theme.palette.secondary.light,
    },
  }),
  { name: 'WbSelectInlineDivider' },
);

// wraps the <Divider /> component and forward all props except for onClick and role,
// which would otherwise be added when cloned by <Select /> and this element would mistakenly be clickable as option in the select menu
export const WbSelectInlineDivider = ({
  className,
  ...props
}: WbSelectInlineDividerProps) => {
  const classes = useStyles();
  return (
    <Divider
      className={clsx(classes.root, className)}
      {...props}
      onClick={undefined}
      role="presentation"
    />
  );
};
